import { render, staticRenderFns } from "./attackRollerSettingsDialog.vue?vue&type=template&id=0627bef2&"
import script from "./attackRollerSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./attackRollerSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports